import HeroSection from './HeroSection';
import JourneySection from './JourneySection';
import PassionSection from './PassionSection';
import PhilosophySection from './PhilosophySection';
import IntroductionDocumentSection from './IntroductionDocumentSection';
import CVSection from './CVSection';
import CTASection from './CTASection';

const About = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <JourneySection />
      <PassionSection />
      <PhilosophySection />
      <IntroductionDocumentSection />
      <CVSection />
      <CTASection />
    </div>
  );
};

export default About;
